export const clinicalHistoryState = {
  IN_PROGRESS: 'En curso',
  CLOSED: 'Cerrada',
  WAITING_APPROVAL: 'Pendiente de aprobación',
  REJECTED: 'Rechazada',
  OFF_PROGRAM: 'Fuera de programa'
}
